module.exports = __webpack_public_path__ + "static/media/181.1ac24543.webp";